module.exports = ".alert-auto-dismiss {\r\n    position: fixed;\r\n    margin-left: 72%;\r\n    padding-top: 20px;\r\n}"